// extracted by css-extract-rspack-plugin
export default {"default":"default-n6QrAB","disabled":"disabled-jcNrzw"};